import type {IAdData} from '../../../definitions';

interface MessageData {
  data: {
    action: string;
  };
}

/** Set ad to bottom fixed. Used by baseboard ad and floorad */
export function handleStickyBottomAd(data: IAdData, adSlotTop: Element | null) {
  const adContainer = data.target;
  const modHeader = document.querySelector<HTMLElement>('.new-header');

  if (adContainer && modHeader) {
    const modHeaderInitialZIndex = modHeader.style.zIndex;
    const expandedClass = 'ad-sticky-bottom-expanded';
    const hideScrollingClass = 'hideScrolling';

    adSlotTop?.classList.add('ad-sticky-bottom');
    document.documentElement.classList.add('has-ad-sticky-bottom');

    window.addEventListener('message', (e: MessageData) => {
      const action = e.data.action;
      if (action === 'ad:mfaxl:remove') {
        // the user wants to remove the ad: we disable the ad container
        adContainer.classList.add('ad-disabled');
      } else if (action === 'ad:mfaxl:open') {
        // expand the ad to its full-screen/overlay form
        document.documentElement.classList.add(hideScrollingClass);
        modHeader.style.zIndex = '0';
        adContainer.classList.add(expandedClass);
      } else if (action === 'ad:mfaxl:close') {
        // collapse the ad to its original small form
        document.documentElement.classList.remove(hideScrollingClass);
        modHeader.style.zIndex = modHeaderInitialZIndex;
        adContainer.classList.remove(expandedClass);
      }
    });
  }
}
